import { createFileRoute, Navigate } from '@tanstack/react-router';
import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { SettingsLayout } from '@/containers/settings/settings-layout.component';
import { SecretsSettings } from '@/containers/settings/secrets/secrets-settings.component';
import { useSecretsSettingsAccess } from '@/containers/settings/secrets/use-secrets-settings-access.hook';

export const Route = createFileRoute('/settings/secrets')({
  component: () => (
    <>
      <Head heading='Secrets' />
      <AuthCheck>
        <SettingsLayout>
          <SecretsPage />
        </SettingsLayout>
      </AuthCheck>
    </>
  ),
});

// Someone who can't manage secrets (a member, or a plan without Agents) lands
// on Account rather than an empty pane, once the answer is in.
function SecretsPage() {
  const { enabled, ready } = useSecretsSettingsAccess();
  if (ready && !enabled) return <Navigate to='/settings/account' replace />;
  return <SecretsSettings />;
}
